import { useMemo, useRef, useState } from 'react'
import { Block, Image } from '@/components/crRender'
import placeholderImg from '@/assets/images/Not_available.jpg'
import ActionBtn from '@/components/ActionBtn'
import '../style.css'
import { FileUploadField } from '../../shared'
import ImgPopup from '@/components/popups/imgPopup'

const getLogo = (Logo) =>{
 return{
    Logo : Logo?.data[Logo?.data?.length - 1]?.name ? window.API_URL + Logo?.data[Logo?.data?.length - 1]?.name : null,
    sourcePath : window.API_URL,
    link : Logo?.data[Logo?.data?.length - 1]?.name 
 }
} 

const ImgProfile = ({ providerInfo, formHandler }) => {

    const [isEditImg, setIsEditImg] = useState(false)
    const [imgLink, setImgLink] = useState(null)

    const showImg = useRef(false)

    const LogoLinks = useMemo(() => {
        const logoObject = providerInfo?.files?.find(file => file.name === 'logo')
        return getLogo(logoObject)
    }, [providerInfo])

    const handleShowImg = () => {
        showImg.current.click()
        setImgLink(LogoLinks.link)
    }


    return (
        <>
            <div className="technology-item-card col-lg-6 mb-2" >
                <Block isRender={!isEditImg} className="profile-img-container">
                    <div>
                        <div className="relative-container">
                            <Image onClick={() => handleShowImg()} placeholder={placeholderImg} src={LogoLinks.Logo} />
                            <ActionBtn
                                icon="carbon:close-filled"
                                className="remove-tech-btn remove-tech-image-btn pointer"
                                onApply={() => setIsEditImg(true)} />
                        </div>

                    </div>
                </Block>
                <Block isRender={!!isEditImg}>
                    <FileUploadField
                        className="col-lg-12 field-img-profile"
                        formHandler={(name,file) => formHandler.handleFormValues(name, { value: file, isRequired: true, isError: false })}
                        name="logo"
                        id={`technology-picture-${providerInfo?.id}`}
                        accept="image/*"
                        maxFiles={1}
                        value={providerInfo?.picture || ''}
                    />
                </Block>
            </div>
            <ImgPopup
                link={LogoLinks.link}
                refImg={showImg}
                sourcePath={LogoLinks.sourcePath}
                isHideText
            />
        </>
    )
}

export default ImgProfile